const defaultState = {
    tutorials: {
        overview: {
            id: 'overview',
            isActive: true,
        },
        searchWorkOrder: {
            id: 'searchWorkOrder',
            isActive: true,
        },
        manageWorkOrder: {
            id: 'manageWorkOrder',
            isActive: true,
        },
        createReport: {
            id: 'createReport',
            isActive: true,
        },
    },
};

const actions = {
    toggleTutorial({ commit }, tutorialName) {
        commit('toggleTutorial', tutorialName);
    },
    turnOnTutorial({ commit }, tutorialName) {
        commit('turnOnTutorial', tutorialName);
    },
    turnOffTutorial({ commit }, tutorialName) {
        commit('turnOffTutorial', tutorialName);
    },
};

const mutations = {
    toggleTutorial(state, tutorialName = '') {
        const tutorial = state.tutorials[tutorialName];
        tutorial.isActive = !tutorial.isActive;
    },
    turnOnTutorial(state, tutorialName = '') {
        const tutorial = state.tutorials[tutorialName];
        tutorial.isActive = true;
    },
    turnOffTutorial(state, tutorialName = '') {
        const tutorial = state.tutorials[tutorialName];
        tutorial.isActive = false;
    },
};

const getters = {
    tutorials: state => state.tutorials,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
